import { z } from "zod";
import { schemes } from "@zeal/common";

export const getInvoiceBulkActionCountsRequestSchema = z.object({
  companyID: schemes.companyID(),
  search: z.string().optional().default(""),
  status: z.string().optional(),
  payment_status: z.string().optional(),
  invoiceDateFrom: z.string().optional(),
  invoiceDateTo: z.string().optional(),
  dueDateFrom: z.string().optional(),
  dueDateTo: z.string().optional(),
  excludeIds: z.array(z.string()).optional().default([]),
});

export type TGetInvoiceBulkActionCountsRequest = z.infer<
  typeof getInvoiceBulkActionCountsRequestSchema
>;

export const getInvoiceBulkActionCountsResponseSchema = z.object({
  approve: z.number(),
  unapprove: z.number(),
  send: z.number(),
  markPaid: z.number(),
  revertToUnpaid: z.number(),
  cancel: z.number(),
  markUncollectible: z.number(),
});

export type TGetInvoiceBulkActionCountsResponse = z.infer<
  typeof getInvoiceBulkActionCountsResponseSchema
>;
